<qm-toast-container></qm-toast-container>
<qm-alarm></qm-alarm>
<qm-app-version-notifier></qm-app-version-notifier>
<router-outlet></router-outlet>
